<template>
    <common-content-spacer height="medium">
        <search-list @search="handleSearch"></search-list>
        <common-loader v-if="isLoading && !patientMembers.length" :isProcessing="isLoading"></common-loader>
        <common-grid v-else>
            <template v-if="patientMembers.length">
                <common-grid-column v-for="member in patientMembers" :key="member.id" class="pateint-member-list">
                    <patient-member-card :physician="member"></patient-member-card>
                </common-grid-column>
            </template>
            <template v-else>
                <div class="no-patients">No patients found</div>
            </template>
        </common-grid>
        <common-buttons>
            <common-button
                v-if="patientMembers.length < patientMembersTotalCount"
                :label="$t('pages.referrals.index.buttons.show_more')"
                :isProcessing="isLoading"
                type="primary"
                size="large"
                @click="showMore()"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
</template>

<script>
    import PatientAPI from 'api/PatientAPI'
    import PatientMemberCard from 'components/page-elements/patient/PatientMemberCard'
    import SearchList from 'components/forms/patient/SearchList'

    export default {
        components: {
            PatientMemberCard,
            SearchList,
        },

        data() {
            return {
                search: '',
                isLoading: false,
                patientMembers: [],
                fullPatientList: [],
                patientMembersTotalCount: 0,
                offset: 0,
                limit: 10,
            }
        },

        methods: {
            fetchPatientMembers({ limit, offset, append = false }) {
                this.isLoading = true
                PatientAPI.getList(this.$auth.getUser().id, {
                    limit,
                    offset,
                })
                    .then((res) => {
                        if (append) {
                            this.fullPatientList = this.fullPatientList.concat(res)
                        } else {
                            this.fullPatientList = res
                            this.patientMembersTotalCount = parseInt(res._headers['x-total-count'])
                        }
                        this.patientMembers = this.fullPatientList
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },

            handleSearch(searchText) {
                this.search = searchText.toLowerCase()
                this.patientMembers = this.fullPatientList.filter((member) => {
                    const fullName = `${member.firstName} ${member.lastName}`.toLowerCase()
                    return fullName.includes(this.search)
                })
            },

            showMore() {
                this.offset = this.offset + this.limit
                this.fetchPatientMembers({ limit: this.limit, offset: this.offset, append: true })
            },
        },

        created() {
            this.fetchPatientMembers({ limit: this.limit, offset: this.offset })
        },
    }
</script>
<style>
    @media (max-width: 1366px) {
        .pateint-member-list.grid__column {
            min-height: auto !important;
            padding-left: 27px;
        }
    }
    .no-patients {
        text-align: center;
        font-size: 16px;
        color: #666;
        padding: 20px 0;
        width: 100%;
    }
</style>
